import React from 'react';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  const painPoints = ['Le pides que deje el celular y te ignora… o explota.', 'Cada cena termina en discusión por las pantallas.', 'Sientes que estás perdiendo la conexión con tu hijo/a.', 'Has intentado quitar el celular, pero solo empeora todo.', 'Te preocupa lo que ve en internet, pero no sabes cómo hablar del tema sin que se cierre.', "Estás agotada de ser la 'mala del cuento' o la policía del internet en tu propia casa."];
  return <section className="bg-alternate py-10 md:py-24 px-4" data-id="element-176">
      <div className="max-w-3xl mx-auto" data-id="element-177">
        <div className="text-center mb-8 md:mb-12" data-id="element-178">
          <h2 className="text-2xl md:text-4xl font-bold text-text-primary mb-3 md:mb-4" data-id="element-179">
            ¿Te suena familiar?
          </h2>
          <div className="w-16 h-1 bg-coral mx-auto rounded-full" data-id="element-180"></div>
        </div>

        <div className="bg-primary rounded-2xl p-5 md:p-10 shadow-soft border border-border" data-id="element-181">
          <ul className="space-y-4 md:space-y-6" data-id="element-182">
            {painPoints.map((point, index) => <li key={index} className="flex items-start gap-3 md:gap-4" data-id="element-183">
                <AlertCircle className="w-5 h-5 md:w-6 md:h-6 text-coral flex-shrink-0 mt-0.5" data-id="element-184" />
                <p className="text-base md:text-lg text-text-primary font-medium leading-relaxed" data-id="element-185">
                  {point}
                </p>
              </li>)}
          </ul>

          <div className="mt-8 md:mt-10 pt-6 md:pt-8 border-t border-border text-center" data-id="element-186">
            <p className="text-lg md:text-xl text-text-secondary italic" data-id="element-187">
              No estás sola. Y lo más importante:{' '}
              <strong className="text-text-primary font-semibold" data-id="element-188">
                no es tu culpa.
              </strong>
            </p>
          </div>
        </div>
      </div>
    </section>;
}